import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { Container, Row, Col, Button } from "react-bootstrap";

import logo from "../../../src/asses/img/parkingl.png";
import * as ROUTES from "../../../src/constans/rutas";
import CasesClosed from "../../components/Cases/CasesClosed";
import CasesOpen from "../../components/Cases/CasesOpen";

const EthicsChannel = () => {
  const [loading, setLoading] = useState(true);
  const [windows, setWindows] = useState(1);
  const history = useHistory();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <Container className="contendor-Principal">
        <Row>
          <Col className="cont_logo" xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className="logo" src={logo}></img>

            <p className="texto-slogan">Sistema De Canal De Etica</p>
          </Col>
        </Row>
        <Row className="justify-content-end ">
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "15px",
            }}
            className="cont_logo"
            xs={12}
            sm={12}
            md={6}
            lg={4}
            xl={4}
          >
            <Button
              style={{ marginRight: "10px" }}
              variant="primary"
              onClick={() => history.push(ROUTES.HOME)}
            >
              <FaHome size={20} style={{ marginRight: "5px" }} />
              HOME
            </Button>
          </Col>
        </Row>
        <Row className="justify-content-end mbottom-20 menu">
          <Col
            className={windows === 1 ? "menu_items2" : "menu_items"}
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={2}
          >
            <button
              onClick={() => {
                setWindows(1);
              }}
            >
              Casos Abiertos
            </button>
          </Col>
          <Col
            className={windows === 2 ? "menu_items2" : "menu_items"}
            xs={4}
            sm={4}
            md={2}
            lg={2}
            xl={2}
          >
            <button
              onClick={() => {
                setWindows(2);
              }}
            >
              Casos Cerrados
            </button>
          </Col>
        </Row>
      </Container>
      <Container>
        {windows === 1 ? <CasesOpen /> : null}
        {windows === 2 ? <CasesClosed /> : null}
      </Container>
    </>
  );
};

export default EthicsChannel;
